module.exports = __webpack_public_path__ + "img/DE01371.968fd215.png";